import {RouterPaths} from "../../app/appConstants";

export const PAGES_ZENDESK_FIXED_BUTTON_HIDDEN = [
    RouterPaths.main,
    RouterPaths.support,
    RouterPaths.trade
];
